import { useAlgoliaApiRecommendedActions } from 'algolia-api/hooks/useAlgoliaApiRecommendedActions';
import { SearchLocation } from 'algolia-api/types/SearchLocation';
import { Box } from 'components/Box';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { TileCarousel } from 'components/TileCarousel';
import { CmsApiRecommendedActionsBlockData } from 'modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';
import { listingSearchHomePath } from 'utils/searchHomePages';

type Props = {
  data: CmsApiRecommendedActionsBlockData;
};

export function CmsRecommendedActionsBlock({
  data: { headline, volopFunction, areaOfFocus, locale },
}: Props) {
  const searchLocation = useMainSelector(
    (state) => state.mainSearch.searchLocation,
  ) as SearchLocation;

  const { data: recommendedActions, isLoading } =
    useAlgoliaApiRecommendedActions(searchLocation, {
      volopFunction,
      areaOfFocus,
      locale,
    });

  if (isLoading) return <LoadingIndicator />;

  const additionalAnalyticsProps: Record<string, string> = {};

  if (volopFunction) additionalAnalyticsProps.volop_function = volopFunction;
  if (areaOfFocus) additionalAnalyticsProps.area_of_focus = areaOfFocus;
  if (locale && locale !== 'all') additionalAnalyticsProps.locale = locale;

  return (
    <Box
      data-qa-id="recommended-actions"
      data-qa-volop-function={volopFunction}
      data-qa-area-of-focus={areaOfFocus}
    >
      <TileCarousel
        headline={headline}
        results={recommendedActions}
        seeAll={{
          text:
            /* TRANSLATORS: Link to actions search */
            getText('See All Volunteer Opportunities'),
          action: { type: 'link', url: listingSearchHomePath('VOLOP') },
        }}
        listingType="ACTION"
        additionalAnalyticsProps={additionalAnalyticsProps}
      />
    </Box>
  );
}
